  var CCF;
  var DEPARTMENT_MAP = {
    "US Specialty / 3415US00": [
      "Aviation",
      "Marketing and Communications",
      "Marine, Cargo, Logistics & Transportation",
      "Construction",
      "Natural Resources",
      "Real Estate",
      "Professional Services",
      "Financial Institutions",
      "Private Equity",
      "Sport & Entertainment",
      "Life Sciences",
      "Healthcare & Education",
      "P&C",
      "SME",
      "Employee Benefits",
      "Private Client",
      "Executive",
      "Food & Beverage",
      "Agriculture",
      "Technology",
      "General Industry",
      "Hospitality",
      "Retail",
      "Middle Market",
      "Higher Education",
      "Professional Employer Or",
      "Cyber",
      "Financial Lines",
      "Property",
      "Casualty",
      "Sales",
      "Multinational",
      "Claims",
      "Global",
      "Inward-Korea",
      "MDI",
      "Super Yacht"
    ],

    "HOWDEN RE / 3410US00": [
      "A306AA","A306AC","A306AD","A306AF","A306AH",
      "A306BC","A4040M","B30208","B30922","B30923","B30924",
      "B30925","B30927","B399AA","B399AB",
      "A01375","A01374"
    ],

    "CAPITAL MARKETS / 3413US00": [
      "A306AR",
      "A306BF"
    ],

    "US DUAL": [
      "A01352","A01354","A01360","A01361","A40401",
      "A40403","A40413","A40417","A40419","A40421",
      "A40422","A40423","A40426","A40427","A40428",
      "A40431","A40432","A40439","A40440","A40442",
      "A40443","A40444","A40445","A40446","A40447",
      "A40448","A40449","A40450","A40451","A40452",
      "A40453","A40454","A40457","A40458","A40459",
      "A40460","B40108","B40414","B49901","B49906",
      "B49907","B49908","B49909","B49910","B49911",
      "B49912","B49913","B49914","B49915","B49916",
      "B49917","B49918"

    ]
  };

  (function(url, position, callback){
        url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
        position = position || 0;
        
        if (!window.jQuery) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement("script");
            script.src = url;
            script.type = 'text/javascript';
            head.appendChild(script);
            head.insertBefore(script,head.childNodes[position]);
  
            script.onload = function(){
                if(typeof callback == 'function') {
                    callback(jQuery);
                }
            };
        } else {
            if(typeof callback == 'function') {
                callback(jQuery);
            }
        }
    }('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function($){
  
        CCF = jQuery.noConflict();
        init_ccf();
    
    }));
  
// }

function init_ccf(){
  //console.log("CCF started");

  CCF(".CCF_fields").hide();

  // check if app is activate
  check_app_activated();

  
}

function validate(target, message) {
  alert(message);
  CCF(target).focus().css('outline', '1px solid #FF0000');
  return false;
}

function check_app_activated() {
  
    var request = CCF.ajax({
      url: "/apps/CCF",
      method: "POST",
      data: {action: "check_store"},
      dataType: "json",
      crossDomain: true
    }); 

    request.done(function( data ) {
      console.log(data);

      if(data.is_valid_store){
        CCF(".CCF_fields").show();
        populateCostCenters();
        set_cart_options(data);
      }
    })
  
}

function populateCostCenters() {
  var $costCenter = CCF('.CostCenterField');

  $costCenter.empty().append('<option value="">Select Cost Center</option>');

  CCF.each(DEPARTMENT_MAP, function (key) {
    $costCenter.append('<option value="' + key + '">' + key + '</option>');
  });
}

function set_cart_options(data) {
 // totals__total-value
var total_price_selector = ".totals .totals__total-value, .totals .totals__subtotal-value, .money bacurr-money buckscc-money";
var total_extra_cost = 0;
var store_currency = CCF('.store_currency').text();
var cart_total = CCF('.cart-total').text();

  
 CCF('.CCF_input').each(function(){
     var $this = CCF(this);
   
  if (CCF(this).is(':checkbox')) {
    var is_additional_cost = CCF(this).data("additional");
        var additional_type = CCF(this).data("additional-type");

      
      if(is_additional_cost!=""){
      
      if(additional_type=="fixed"){
         if (CCF(this).is(':checked')) {
         total_extra_cost = total_extra_cost+ is_additional_cost;
        }
      }else{
        
          var ct =    (Number(cart_total)/100);
          var add_cost = (ct/100) * is_additional_cost;
          if ($this.is(':checked')) {
              total_extra_cost = total_extra_cost+ add_cost;
          
          }
      
      }
       
    }
  }
   
 });


if(total_extra_cost>0){
  

  
         var last_price = (Number(cart_total))/100 + total_extra_cost;
    var price_last = store_currency.replace("{{amount}}",last_price.toFixed(2));
   CCF(total_price_selector).html(price_last);  
    
 
    
}

  
    
      
CCF('body').on('change', '.CostCenterField', function () {

  var selectedVal = CCF(this).val();
  var $wrapper = CCF('#department_code');
  var $select  = CCF('.DeparmentCodeField');

  $select.empty().append('<option value="">Select</option>');

  if (DEPARTMENT_MAP[selectedVal]) {
    CCF.each(DEPARTMENT_MAP[selectedVal], function (_, val) {
      $select.append('<option value="' + val + '">' + val + '</option>');
    });
    $wrapper.show();
  } else {
    $wrapper.hide();
  }
});

 CCF('body').on(
  'click',
  ".CCF_checkout_btn,#dvPaypal,#dvAmazon,input[name='checkout'],button[name='checkout'],[href$='checkout'],input[name='goto_pp'],button[name='goto_pp'],input[name='goto_gc'],button[name='goto_gc'],.additional-checkout-button,.google-wallet-button-holder,.amazon-payments-pay-button",
  function (ev) {

    ev.preventDefault();

    /* ---------------- NOTE ---------------- */
    var note = '';
    if (CCF("[name='note']").length) {
      note = CCF("[name='note']").val();
    }
    if (CCF("[name='cart[note]']").length) {
      note = CCF("[name='cart[note]']").val();
    }

    /* ------------- VALIDATION ------------- */
    var validate_pass = true;
    var attributes_arr = {};
    var add_cost_arr = [];

    CCF('.CCF_input').not(':radio').each(function () {

      var $field = CCF(this);
      var attr_val = ($field.val() || '').trim();

      var attr_key_match = $field.attr('name').match(/\[(.*?)\]/);
      if (!attr_key_match) return;

      var key = attr_key_match[1];

      var $deptField = CCF('.DeparmentCodeField');
      var departmentCode_val = ($deptField.val() || '').trim();

      var is_required = $field.data('required') === true || $field.data('required') === 'true';
      var is_required_code = $deptField.is(':visible');

      $field.css('outline', 'none');
      $deptField.css('outline', 'none');

      /* Required cost centre */
      if (is_required && attr_val === '') {
        validate_pass = false;
        return validate(this, key + ' field is required');
      }

      /* Required department dropdown */
      if (is_required_code && departmentCode_val === '') {
        validate_pass = false;
        return validate($deptField, 'Department Code field is required');
      }

      /* Combine only when department is visible */
      var combined_val = attr_val;
      if (is_required_code) {
        combined_val = attr_val + ' - ' + departmentCode_val;
      }

      attributes_arr[key] = combined_val;
    });

    if (!validate_pass) {
      return false;
    }

    /* ------------ UPDATE CART ------------- */
    var attributes = {
      attributes: attributes_arr,
      note: note
    };

    CCF.ajax({
      url: '/cart/update.js',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(attributes),
      dataType: 'json'
    }).done(function (cart) {

      if (add_cost_arr.length > 0) {
        create_draft_order(add_cost_arr, cart);
      } else {
        window.location = '/checkout';
      }
    });

    return false;
  });


function  create_draft_order(add_cost_arr, cart) {

  var add_cost_data = JSON.stringify(add_cost_arr);
  var cart = JSON.stringify(cart);

  var request = CCF.ajax({
      url: "/apps/CCF",
      method: "POST",
      data: {action: "create_draft_order", add_cost_data: add_cost_data, cart: cart},
      dataType: "json",
      crossDomain: true
    }); 

  request.done(function( data ) {
    console.log(data);

    if(data.success){
      window.location = data.success.invoice_url;
    }else{
      
    }

    
  });
}}

